import * as dataLayer from "../../../../global/js/dataLayer";
import _ from 'lodash';

// CONSTANTS are all caps.
const NS = 'InpageSubmission';
const CLS = 'InpageSubmission';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

export class InpageSubmission {
	constructor($el) {
		// $el is the blk node return by the loadInpageSubmission function
		this.$el = $el;
		this.$queryBlock = $($el);
		this.options = {
			observerConfig: {
				attributes: true,
				childList: true,
				subtree: true,
			},
			mappings: _.merge({
				contextdatavalue_PurchaseArea: (value) => ({
					customKey: 'review_product_location',
					customValue: value === 'InStore' ? 'in-store' : 'online',
				}),
				hostedauthentication_authenticationemail: false,
				rating: 'rating',
				reviewtext: 'review_text',
				title: 'review_title',
				usernickname: 'review_name',
			}, window.settingBVMappings || {}),
			defaultDataLayer: {
				event: 'review-submited',
				name: _.get(window, 'productDetailsJson.title', ''),
			},
		};
		this.windowParse = window.JSON.parse;
		this.customParse = (text, reviver) => {
			const json = this.windowParse(text, reviver);
			this.onSubmitedInpage(json);

			return json;
		}
	}

	init() {
		this.setInpageSubmission();
	}

	setInpageSubmission() {
		this.registerEvent();
	}

	registerEvent() {
		if (window.BV) {
			window.BV && window.BV.swat_reviews.on('onCloseInpage', () => {
				window.JSON.parse = this.windowParse;
			});

			window.BV && BV.inpage_submission.on('show_form', () => {
				window.JSON.parse = this.customParse;
				this.$queryBlock.removeClass('d-none');
			});
		}
	}

	onSubmitedInpage(json) {
		const mappings = this.options.mappings;
		const mappingList = Object.keys(mappings);
		const notDataForm = mappingList.find((key) => json[key] === undefined);

		if (!notDataForm) {
			const data = mappingList.reduce((acc, key) => {
				if (mappings[key]) {
					if (_.isFunction(mappings[key])) {
						const { customKey, customValue } = mappings[key](json[key]);
						acc[customKey] = customValue;
					} else {
						acc[mappings[key]] = json[key];
					}
				}
				return acc;
			}, this.options.defaultDataLayer);

			dataLayer.pushReviewSubmited(data);
			window.JSON.parse = this.windowParse;
		}
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/408/s/FrontEnd/src/views/blocks/inpageSubmission/js/inpageSubmission.js